"use client";

import React from "react";
import { motion } from "framer-motion";
import Image from "next/image";

export default function OdooBadges() {
  return (
    <section className="py-8 px-6 sm:px-12 relative z-10 -mt-20 md:-mt-28 mb-20">
      <div className="container mx-auto">
        <div className="bg-black rounded-[2.5rem] p-10 md:p-14 shadow-[0_25px_60px_rgba(0,0,0,0.4)] max-w-5xl mx-auto relative overflow-hidden">
          {/* Decorative subtle glows for premium feel */}
          <div className="absolute -top-24 -left-24 w-64 h-64 bg-[#f1833b]/10 rounded-full blur-3xl" />
          <div className="absolute -bottom-24 -right-24 w-64 h-64 bg-[#003366]/10 rounded-full blur-3xl" />
          
          <div className="grid grid-cols-2 gap-8 md:gap-24 justify-items-center items-center relative z-10">
            <motion.div 
              className="flex flex-col items-center cursor-pointer"
              animate={{
                scale: [1, 1.03, 0.99, 1.03, 1]
              }}
              transition={{
                duration: 1.6,
                repeat: Infinity,
                ease: "easeInOut"
              }}
            >
              <Image 
                src="/assets/img/odoo/odoo-badge-100-1.png" 
                alt="Odoo 100+ Implementation" 
                width={200}
                height={160}
                className="h-28 md:h-40 w-auto object-contain drop-shadow-[0_10px_20px_rgba(0,0,0,0.1)]" 
              />
            </motion.div>
            <motion.div 
              className="flex flex-col items-center cursor-pointer"
              animate={{
                scale: [1, 1.03, 0.99, 1.03, 1]
              }}
              transition={{
                duration: 1.6,
                repeat: Infinity,
                ease: "easeInOut"
              }}
            >
              <Image 
                src="/assets/img/odoo/odoo-badge-certified-1.png" 
                alt="Odoo Certified Experts" 
                width={200}
                height={160}
                className="h-28 md:h-40 w-auto object-contain drop-shadow-[0_10px_20px_rgba(0,0,0,0.1)]" 
              />
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
